import React, { useEffect, useState, useRef } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import {
  DropDownList,
  MultiSelect,
  AutoComplete,
} from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Circles} from "react-loader-spinner";
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import * as TMSservice from "./approverMatrixService";
import "./ApproverMatrix.scss";
import {
  Dialog,
  DialogActionsBar,
  Window,
} from "@progress/kendo-react-dialogs";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { process } from "@progress/kendo-data-query";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import NumberFormat from "react-number-format";
import { element } from "prop-types";

const dataState = {
  sort: [],
  take: 10,
  skip: 0,
};

class ApproverMatrix extends React.Component {
  _export;
  export = () => {
    this._export.save();
  };

  constructor(props) {
    super();
    this.state = {
      blocking: false,
      segmentData: [],
      selectSegment: { text: "Select Segment", value: "Select Segment" },
      authorizerData: [],
      selectedAuth: "",
      selectedAuthToDisplay: "",
      visible: false,
      Formvisible: false,
      windowTitle: "",
      segmentModalValue: "",
      currencyModalValue: "",
      approverlevel1Value: "",
      approverlevel2Value: "",
      approverlevel3Value: "",
      SubmitbuttonName: "",
      ddData: [],
      addButtonDisabled: true,
      editButtonDisabled: true,
      deleteDisabled: true,
      exportDisabled: true,
      searchDisabled: true,
      authorizerTextDisabled: false,
      approverSegments: [],
      userDetails: [],
      gridDataNew: [],
      editOrAdd: "",
      dataState: dataState,
    };
    this.toggleDialog = this.toggleDialog.bind(this);
  }

  async getSegmentData() {
    let _segmentData = [{ value: "00000000", text: "ALL" }];
    const response = await TMSservice.getSegments();
    _segmentData.push(...response);
    this.setState({ segmentData: _segmentData });
  }

  async getFirstLevelApproverData() {
    if (this.state.selectSegment.text == "Select Segment") {
      toast.error("Please select segment",{theme:"colored"});
    } else {
      var inputObj1 = {};
      inputObj1["segment"] = this.state.selectSegment.value;
      inputObj1["slab"] = "10000-50000";
      // const response = await TMSservice.getApproverData(inputObj);
      let props = {};
      let inputObj = {};
      let InputJSONString = "";
      props["query"] = constants.serviceRoot;
      props["headers"] = constants.serviceHeaders;
      InputJSONString = JSON.stringify(inputObj1);
      inputObj["Activity"] = "APPR_GET_LIST";
      inputObj["Input"] = InputJSONString;
      props.input = inputObj;

      const response = await GatewayGet(props, props.input);
      if (response != undefined || response != null) {
        this.setState({ ddFirstLevelData: response });
        this.getSecondLevelApproverData();
      } else {
        toast.error("Error in getting the first level Approver Data",{theme:"colored"});
        this.setState({ ddFirstLevelData: [] });
      }
    }
  }
  async getSecondLevelApproverData() {
    if (this.state.selectSegment.text == "Select Segment") {
      toast.error("Please select segment",{theme:"colored"});
    } else {
      var inputObj1 = {};
      inputObj1["segment"] = this.state.selectSegment.value;
      inputObj1["slab"] = "50000-100000";
      // const response = await TMSservice.getApproverData(inputObj);
      let props = {};
      let inputObj = {};
      let InputJSONString = "";
      props["query"] = constants.serviceRoot;
      props["headers"] = constants.serviceHeaders;
      InputJSONString = JSON.stringify(inputObj1);
      inputObj["Activity"] = "APPR_GET_LIST";
      inputObj["Input"] = InputJSONString;
      props.input = inputObj;

      const response = await GatewayGet(props, props.input);
      if (response != undefined || response != null) {
        this.setState({ ddSecondLevelData: response });
        this.getThirdLevelApproverData();
      } else {
        toast.error("Error in fetching the second Level Approver Data",{theme:"colored"});
        this.setState({ ddSecondLevelData: [] });
      }
    }
  }
  async getThirdLevelApproverData() {
    if (this.state.selectSegment.text == "Select Segment") {
      toast.error("Please select segment",{theme:"colored"});
    } else {
      var inputObj1 = {};
      inputObj1["segment"] = this.state.selectSegment.value;
      inputObj1["slab"] = "100000-9999999.990";
      // const response = await TMSservice.getApproverData(inputObj);
      let props = {};
      let inputObj = {};
      let InputJSONString = "";
      props["query"] = constants.serviceRoot;
      props["headers"] = constants.serviceHeaders;
      InputJSONString = JSON.stringify(inputObj1);
      inputObj["Activity"] = "APPR_GET_LIST";
      inputObj["Input"] = InputJSONString;
      props.input = inputObj;

      const response = await GatewayGet(props, props.input);

      if (response != null || response != undefined) {
        this.setState({ ddThirdLevelData: response });
        console.log("*** ddThirdLevelData *** ", this.state.ddThirdLevelData);
      } else {
        this.setState({ ddThirdLevelData: [] });
      }
    }
  }

  async getAuthorizerData(input) {
    if (input.text == "Select Segment") {
      toast.error("Please select segment",{theme:"colored"});
    } else {
      var authorizerArray = [];
      var inputobj = {};
      inputobj["Segment"] = input.value;
      const response = await TMSservice.getAuthList(inputobj);
      this.setState({ segmentAuthArray: response });
      for (var i = 0; i < response.length; i++) {
        authorizerArray.push(response[i].USERNAME + "-" + response[i].EMAIL);
      }
      this.setState({
        approverData: authorizerArray,
        authorizerData: authorizerArray,
        authMasterData: response,
      });
    }
  }

  async getApproverMatrixData(input) {
    const response = await TMSservice.getApproverMatrixData(input);
    if (response.LIST === undefined) {
      this.setState({
        gridData: [],
        gridDataNew: [],
        editButtonDisabled: true,
        deleteDisabled: true,
        exportDisabled: true,
      });

      if (this.state.selectedAuth == "") {
        this.setState({ addButtonDisabled: true });
      } else {
        this.setState({ addButtonDisabled: false });
      }
    } else {
      let tableData = await this.getDataWWIDMerged(response.LIST);

      this.setState({ gridDataNew: tableData, exportDisabled: false });
      this.setState({ gridData: response.LIST });

      if (this.state.selectedAuth == "") {
        this.setState({
          editButtonDisabled: true,
          deleteDisabled: true,
          addButtonDisabled: true,
        });
      } else {
        this.setState({
          editButtonDisabled: false,
          deleteDisabled: false,
          addButtonDisabled: true,
        });
      }
    }
  }

  async getDataWWIDMerged(approversData) {
    let creators = [];
    let finalApproversData = [];

    approversData.map((data) => {
      if (data.CREATOR == data.APPROVER && data.AMOUNT_HIGH == 10000)
        creators.push(data.CREATOR);
    });
    for (let i = 0; i < creators.length; i++) {
      let approverObject = {};
      approversData.map((data) => {
        if (data.CREATOR == creators[i]) {
          approverObject.creator = data.CREATOR;
          approverObject.externalID_org_segment = data.EXTERNAL_ID;
        }
        if (data.CREATOR == creators[i] && data.AMOUNT_LOW == 10000)
          approverObject.approver10k = data.APPROVER;
        if (data.CREATOR == creators[i] && data.AMOUNT_LOW == 50000)
          approverObject.approver50k = data.APPROVER;
        if (data.CREATOR == creators[i] && data.AMOUNT_LOW == 100000)
          approverObject.approver100k = data.APPROVER;
      });

      if (this.state.segmentAuthArray.length) {
        let userDetail = this.state.segmentAuthArray.filter(
          (element) => element.USERNAME == creators[i]
        );

        if (userDetail.length) {
          approverObject.idsid = userDetail[0].USERNAME;
          approverObject.wwid = userDetail[0].WWID;
          approverObject.name = userDetail[0].FULLNAME;
          approverObject.email = userDetail[0].EMAIL;
        }
      }
      finalApproversData.push(approverObject);
    }
    return finalApproversData;
  }

  async getApproverSegment() {
    let props = {};
    let inputObj = {};
    var inputObj1 = {};
    inputObj1["segment"] = this.state.selectSegment.value;
    var InputJSONString = JSON.stringify(inputObj1);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "APPR_SEGMENT_LIST";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);

    this.setState({ ddData: result });
  }

  async searchData() {
    await this.getApproverSegment();

    var inputObj2 = {};
    inputObj2["segment"] = this.state.selectSegment.value;
    inputObj2["approver"] = this.state.selectedAuth.split("-")[0];
    await this.getApproverMatrixData(inputObj2);
    this.setState({ dataState:  {
      sort: [],
      take: 10,
      skip: 0,
    } });
  }

  async getApproverSegmentData() {
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;

    inputObj["Activity"] = "APPR_SEGMENT_LIST";
    inputObj["Input"] = "";
    props.input = inputObj;

    const response = await GatewayGet(props, props.input);
    console.log(response);
    this.setState({ approverSegments: response });
  }

  async componentDidMount() {
    let profile = JSON.parse(sessionStorage.getItem("profile"));
    //     this.setState({userDetails : profile});
    let props = {};
    let inputObj = {};

    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    // inputObj["Activity"] = "APPR_SEGMENT_LIST";
    // inputObj["Input"] = "";
    // props.input = inputObj;

    // const result = await GatewayGet(props, props.input);

    // this.setState({approverSegments : result});

    var inputobj1 = {};
    inputobj1["Segment"] = "*";
    let InputJSONString = JSON.stringify(inputobj1);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "AUTH_GET_LIST";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const authResult = await GatewayGet(props, props.input);

    this.setState({ authList: authResult });

    this.getSegmentData();
    this.getApproverSegmentData();
  }
  onApproverChange = (event) => {
    const value = event.target.value;
    console.log(this.state.approverData);
    this.setState({
      approverData: this.filterData(value),
      value: value,
      selectedAuth: value,
      selectedAuthToDisplay: value
    });
  };

  validateInputField(input) {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (input.match(validRegex)) {
      return true;
    } else return false;
  }

  onBlurApprover = (event) => {
    var checkForAuthName = "";

    var authExists = "";

    if (this.state.selectSegment.text == "Select Segment") {
      toast.error("Please select the segment",{theme:"colored"});
      return;
    } else {
      //check whether the input is email or idsid

      var isEmail = this.validateInputField(event.value);
      if (isEmail == false) {
        if (this.state.approverData.length == 0) {
          var idsid = event.value;
          // checkForAuthName = this.state.approverSegments.filter(function(e) { return e === this.state.selectedAuth.split("-").split[0] });
          checkForAuthName = this.state.approverSegments.filter(
            (e) => e.APPROVER == idsid.toUpperCase()
          );
          authExists = this.state.authList.filter(
            (e) => e.USERNAME == idsid.toUpperCase()
          );
          console.log(this.state.authList);
          // authExists = this.state.authList.filter((e) => )

          if (checkForAuthName.length > 0) {
            this.setState({
              visible: true,
              addButtonDisabled: true,
              selectedAuth: idsid.toUpperCase(),
              errorMessage: "Authorizer exists in different segments",
            });
            return false;
          } else {
            if (authExists.length > 0)
              this.setState({
                visible: true,
                addButtonDisabled: false,
                selectedAuth: idsid.toUpperCase(),
                errorMessage:
                  "Authorizer doesnt have a approval Matrix, please add..",
              });
            else {
              this.setState({
                visible: true,
                addButtonDisabled: true,
                selectedAuth: idsid.toUpperCase(),
                errorMessage: "Authorizer Invalid",
              });
              return false;
            }
          }
        } else {
          if (event.value != "")
            this.setState({
              selectedAuth: event.value,
              addButtonDisabled: true,
              selectedAuth: event.value,
            });
        }
      } else {
        // if email is true. Check whether the data exists for the entered email id.
        if (this.state.approverData.length == 0) {
          var email = event.value;

          checkForAuthName = this.state.approverSegments.filter(
            (e) => e.EMAIL == email.toLowerCase()
          );
          authExists = this.state.authList.filter(
            (e) => e.EMAIL == email.toLowerCase()
          );
          console.log(this.state.authList);
          // authExists = this.state.authList.filter((e) => )

          if (checkForAuthName.length > 0) {
            this.setState({
              visible: true,
              addButtonDisabled: true,
              selectedAuth: checkForAuthName[0].USERNAME,
              errorMessage: "Authorizer exists in different segments",
            });
            return false;
          } else {
            if (authExists.length > 0)
              this.setState({
                visible: true,
                addButtonDisabled: false,
                selectedAuth: authExists[0].USERNAME,
                errorMessage:
                  "Authorizer doesnt have a approval Matrix, please add..",
              });
            else {
              this.setState({
                visible: true,
                addButtonDisabled: true,
                selectedAuth: event.value,
                errorMessage:
                  "Authorizer doesnt exist or he might not have the Requestor role",
              });
              return false;
            }
          }
        } else {
          //Get the IDSID of the email entered.

          if (event.value != "") {
            var input = event.value;
            var idsid = input.split("-")[0];

            this.setState({ selectedAuth: event.value, selectedAuth: idsid });
          }
        }
      }
    }
    //  if(event.value === "" || event.value.length < 4)
    if (event.value === "") {
      this.setState({
        selectedAuth: event.value,
        editButtonDisabled: true,
        deleteDisabled: true,
        selectedAuth: "",
      });
    }
  };

  async deleteApproverMatrix(input) {
    const response = await TMSservice.DeleteApproverData(input);

    if (response.STATUS == "Success") {
      toast.success("Approval Matrix deleted",{theme:"colored"});

      this.setState({
        addButtonDisabled: false,
        deleteDisabled: true,
        editButtonDisabled: true,
        gridData: [],
        gridDataNew: []
      });
    }
  }

  toggleDialog() {
    this.setState({ visible: false, gridData: [],gridDataNew: [] });
  }

  cancelDialog() {
    this.setState({ deletevisible: false });
  }

  async deleteApprovalData() {
    this.setState({ deletevisible: false });
    var inputObj = {};
    inputObj["Segment"] = this.state.selectSegment.value;
    inputObj["Approver"] = this.state.selectedAuth.split("-")[0];
    await this.deleteApproverMatrix(inputObj);
    this.searchData();
  }

  handleSegmentChange = async (event) => {
    if (event.target.value.value == "00000000") {
      this.setState({
        authorizerTextDisabled: true,
        addButtonDisabled: true,
        deleteDisabled: true,
        editButtonDisabled: true,
        selectedAuth: "",
        selectedAuthToDisplay: ""
      });
    } else {
      this.setState({
        authorizerTextDisabled: false,
        addButtonDisabled: true,
        deleteDisabled: true,
        editButtonDisabled: true,
        selectedAuth: "",
        selectedAuthToDisplay: ""
      });
    }

    this.setState({ selectSegment: event.target.value });
    await this.getAuthorizerData(event.target.value);
    this.setState({ searchDisabled: false });
  };

  filterData(value) {
    const data = this.state.authorizerData;
    const filter = {
      value: value,
      operator: "contains",
      ignoreCase: true,
    };
    return value ? filterBy(data, filter) : data;
  }

  approverLevel1Change = (event) => {
    const value = event.target.value;
    if (
      this.state.approverlevel2Value != "" ||
      this.state.approverlevel3Value.length != ""
    ) {
      if (value.APPROVER == this.state.approverlevel2Value.USERNAME) {
        toast.error("Both the approvers cannot be the same",{theme:"colored"});
        return;
      }
      if (value.APPROVER == this.state.approverlevel3Value.USERNAME) {
        toast.error("Both the approvers cannot be the same",{theme:"colored"});
        return;
      } else this.setState({ approverlevel1Value: value });
    } else this.setState({ approverlevel1Value: value });
  };

  approverLevel2Change = (event) => {
    const value = event.target.value;
    if (
      this.state.approverlevel1Value != "" ||
      this.state.approverlevel3Value.length != ""
    ) {
      if (value.USERNAME == this.state.approverlevel1Value.USERNAME) {
        toast.error("Both the approvers cannot be the same",{theme:"colored"});
        return;
      }
      if (value.USERNAME == this.state.approverlevel3Value.USERNAME) {
        toast.error("Both the approvers cannot be the same",{theme:"colored"});
        return;
      } else this.setState({ approverlevel2Value: value });
    } else this.setState({ approverlevel2Value: value });
  };

  approverLevel3Change = (event) => {
    const value = event.target.value;
    if (
      this.state.approverlevel1Value != "" ||
      this.state.approverlevel2Value.length != ""
    ) {
      if (value.APPROVER == this.state.approverlevel1Value.USERNAME) {
        toast.error("Both the approvers cannot be the same",{theme:"colored"});
        return;
      }
      if (value.APPROVER == this.state.approverlevel2Value.USERNAME) {
        toast.error("Both the approvers cannot be the same",{theme:"colored"});
        return;
      } else this.setState({ approverlevel3Value: value });
    } else this.setState({ approverlevel3Value: value });
  };

  addNew() {
    this.setState({
      Formvisible: true,
      windowTitle: "Add New Approver Matrix",
      SubmitbuttonName: "Save",
      segmentModalValue: this.state.selectSegment.text,
      currencyModalValue: "USD",
      editOrAdd: "ADD",
      approverlevel1Value: [],
      approverlevel2Value: [],
      approverlevel3Value: [],
      authModalValue: this.state.selectedAuth.split("-")[0],
    });
    this.getFirstLevelApproverData();
    // this.getSecondLevelApproverData();
    // this.getThirdLevelApproverData();
  }

  deleteRecord() {
    this.setState({ deletevisible: true });
  }

  async editData() {
    this.getFirstLevelApproverData();
    // this.getSecondLevelApproverData();
    // this.getThirdLevelApproverData();
    this.setState({
      Formvisible: true,
      windowTitle: "Edit Approver Matrix",
      SubmitbuttonName: "Update",
      segmentModalValue: this.state.selectSegment.text,
      currencyModalValue: "USD",
      authModalValue: this.state.selectedAuth.split("-")[0],
      editOrAdd: "EDIT",
    });
    if (this.state.gridData.length == 2)
      this.state.approverlevel1Value = {
        USERNAME: this.state.gridData[1].APPROVER,
        FULLNAME: this.getFullName(this.state.gridData[1].APPROVER),
      };
    else if (this.state.gridData.length == 3) {
      this.state.approverlevel1Value = {
        USERNAME: this.state.gridData[1].APPROVER,
        FULLNAME: this.getFullName(this.state.gridData[1].APPROVER),
      };
      this.state.approverlevel2Value = {
        USERNAME: this.state.gridData[2].APPROVER,
        FULLNAME: this.getFullName(this.state.gridData[2].APPROVER),
      };
    } else if (this.state.gridData.length == 4) {
      this.state.gridData.map((eachApprover) => {
        if (eachApprover.AMOUNT_LOW == 10000)
          this.state.approverlevel1Value = {
            USERNAME: eachApprover.APPROVER,
            FULLNAME: this.getFullName(eachApprover.APPROVER),
          };

        if (eachApprover.AMOUNT_LOW == 50000)
          this.state.approverlevel2Value = {
            USERNAME: eachApprover.APPROVER,
            FULLNAME: this.getFullName(eachApprover.APPROVER),
          };

        if (eachApprover.AMOUNT_LOW == 100000)
          this.state.approverlevel3Value = {
            USERNAME: eachApprover.APPROVER,
            FULLNAME: this.getFullName(eachApprover.APPROVER),
          };
      });
    }
  }

  getFullName(username) {
    var fullName = "";
    for (var i = 0; i < this.state.ddData.length; i++) {
      if (this.state.ddData[i].APPROVER == username) {
        var usernameParts = this.state.ddData[i].FULLNAME;
        fullName = usernameParts;
      }
    }
    return fullName;
  }

  getFileName = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;
    return `ApprovalMatrix_${today}`;
  };

  async postApproverMatrixData(input) {
    const response = await TMSservice.updateApproverData(input);

    if (response.length > 0) {
      if (this.state.editOrAdd == "EDIT") {
        toast.success("Approval Matrix updated Successfully!!!!",{theme:"colored"});
        var inputObj2 = {};
        inputObj2["segment"] = this.state.selectSegment.value;
        inputObj2["approver"] = this.state.selectedAuth.split("-")[0];
        this.getApproverMatrixData(inputObj2);
        this.setState({
          addButtonDisabled: true,
          editButtonDisabled: false,
          deleteDisabled: false,
        });
      } else {
        toast.success("Approval Matrix Added Successfully!!!",{theme:"colored"});
        var inputObj2 = {};
        inputObj2["segment"] = this.state.selectSegment.value;
        inputObj2["approver"] = this.state.selectedAuth.split("-")[0];
        this.getApproverMatrixData(inputObj2);
        this.setState({
          addButtonDisabled: true,
          editButtonDisabled: false,
          deleteDisabled: false,
        });
      }
    }

    console.log(response);
  }

  submitData() {
    //Validations

    if (
      this.state.approverlevel1Value == "" ||
      this.state.approverlevel2Value == "" ||
      this.state.approverlevel3Value == ""
    ) {
      toast.error("Please select all the approver data",{theme:"colored"});
      return;
    } else {
      this.setState({ Formvisible: false });
      var finalArray = [];

      var inputObj = {};
      inputObj["MANDT"] = "";
      inputObj["CREATOR"] = this.state.authModalValue;
      inputObj["AMOUNT_LOW"] = "";
      inputObj["AMOUNT_HIGH"] = "10000";
      inputObj["CURRENCY"] = "USD";
      inputObj["APPROVER"] = this.state.authModalValue;
      inputObj["SEGMENT"] = this.state.selectSegment.value;
      inputObj["DELG_APPROVER"] = "";
      inputObj["VALID_FROM"] = "";
      inputObj["VALID_TO"] = "";
      inputObj["UPDATED_BY"] = this.state.userDetails.USER_ID;
      inputObj["UPDATED_TIME"] = "";
      finalArray.push(inputObj);

      var approverlevel1Obj = {};
      approverlevel1Obj["MANDT"] = "";
      approverlevel1Obj["CREATOR"] = this.state.authModalValue;
      approverlevel1Obj["AMOUNT_LOW"] = "10000";
      approverlevel1Obj["AMOUNT_HIGH"] = "50000";
      approverlevel1Obj["CURRENCY"] = "USD";
      approverlevel1Obj["APPROVER"] = this.state.approverlevel1Value.USERNAME;
      approverlevel1Obj["SEGMENT"] = this.state.selectSegment.value;
      approverlevel1Obj["DELG_APPROVER"] = "";
      approverlevel1Obj["VALID_FROM"] = "";
      approverlevel1Obj["VALID_TO"] = "";
      approverlevel1Obj["UPDATED_BY"] = this.state.userDetails.USER_ID;
      approverlevel1Obj["UPDATED_TIME"] = "";
      finalArray.push(approverlevel1Obj);

      var approverlevel2Obj = {};
      approverlevel2Obj["MANDT"] = "";
      approverlevel2Obj["CREATOR"] = this.state.authModalValue;
      approverlevel2Obj["AMOUNT_LOW"] = "50000";
      approverlevel2Obj["AMOUNT_HIGH"] = "100000";
      approverlevel2Obj["CURRENCY"] = "USD";
      approverlevel2Obj["APPROVER"] = this.state.approverlevel2Value.USERNAME;
      approverlevel2Obj["SEGMENT"] = this.state.selectSegment.value;
      approverlevel2Obj["DELG_APPROVER"] = "";
      approverlevel2Obj["VALID_FROM"] = "";
      approverlevel2Obj["VALID_TO"] = "";
      approverlevel2Obj["UPDATED_BY"] = this.state.userDetails.USER_ID;
      approverlevel2Obj["UPDATED_TIME"] = "";
      finalArray.push(approverlevel2Obj);

      var approverlevel3Obj = {};
      approverlevel3Obj["MANDT"] = "";
      approverlevel3Obj["CREATOR"] = this.state.authModalValue;
      approverlevel3Obj["AMOUNT_LOW"] = "100000";
      approverlevel3Obj["AMOUNT_HIGH"] = "9999999.990";
      approverlevel3Obj["CURRENCY"] = "USD";
      approverlevel3Obj["APPROVER"] = this.state.approverlevel3Value.USERNAME;
      approverlevel3Obj["SEGMENT"] = this.state.selectSegment.value;
      approverlevel3Obj["DELG_APPROVER"] = "";
      approverlevel3Obj["VALID_FROM"] = "";
      approverlevel3Obj["VALID_TO"] = "";
      approverlevel3Obj["UPDATED_BY"] = this.state.userDetails.USER_ID;
      approverlevel3Obj["UPDATED_TIME"] = "";
      finalArray.push(approverlevel3Obj);
      this.postApproverMatrixData(finalArray);
      console.log(finalArray);
    }
  }

  closeWindow() {
    this.setState({ Formvisible: false });
  }
  render() {
    const grid = (
      <ExcelExport
        data={this.state.gridDataNew}
        fileName={this.getFileName()}
        ref={(exporter) => (this._export = exporter)}
      >
        <Grid
          ScrollMode="scrollable"
          style={{ height: "600px", width: "auto",border: "1px solid #0071c5" }}
          pageable={true}
          sortable
          filterable
          total={this.state.gridDataNew.length}
          data={process(this.state.gridDataNew, this.state.dataState)}
          {...this.state.dataState}
          onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
          }}
          ref={(grid) => {
            this._grid = grid;
          }}
        >
          <GridToolbar>
            <div>
              <button
                className="btn k-button k-button-icontext"
                disabled={this.state.addButtonDisabled}
                onClick={this.addNew.bind(this)}
              >
                Add
              </button>
            </div>
            <div>
              <button
                className="btn k-button k-button-icontext "
                disabled={this.state.editButtonDisabled}
                onClick={this.editData.bind(this)}
              >
                Edit
              </button>
            </div>
            <div>
              <button
                className="btn k-button k-button-icontext rejectbtn"
                disabled={this.state.deleteDisabled}
                onClick={this.deleteRecord.bind(this)}
              >
                Delete
              </button>
            </div>
            <div>
              <button
                className="btn k-button k-button-icontext"
                disabled={this.state.exportDisabled}
                onClick={this.export}
              >
                Export to Excel
              </button>
            </div>
          </GridToolbar>

          <GridColumn field="externalID_org_segment" title="Org" />
          <GridColumn field="creator" title="IDSID" />
          <GridColumn field="wwid" title="WWID" />
          <GridColumn field="name" title="Name" />
          <GridColumn field="email" title="Email" />
          <GridColumn field="approver10k" title="$10k-$50k Approver" />
          <GridColumn field="approver50k" title="$50k-$100k Approver" />
          <GridColumn field="approver100k" title="$100k-$10m Approver" />
        </Grid>
      </ExcelExport>
    );
    return (
      <div className="Approver-Matrix">
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={
            <Circles
            color="#00BFFF"
            height="100"
            width="100"
            timeout="6000" //3 secs
          />
          }
        >
          <div>
            {/* <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
/> */}
            {/* Same as */}
            {/* <ToastContainer /> */}
            {this.state.Formvisible && (
              <Window
                title={this.state.windowTitle}
                onClose={this.closeWindow.bind(this)}
                initialHeight={500}
                initialWidth={500}
                className="k-animation-container k-dialog-wrapper"
              >
                <form className="k-form">
                  <fieldset>
                    <legend></legend>

                    <MDBContainer>
                      <MDBRow>
                        <MDBCol>
                          <label>
                            Segment<em>*</em>
                          </label>
                        </MDBCol>

                        <MDBCol>
                          <input
                            type="text"
                            value={this.state.segmentModalValue}
                            disabled={true}
                            className="textbox"
                          />
                        </MDBCol>
                      </MDBRow>
                      <br></br>
                      <MDBRow>
                        <MDBCol>
                          <label>
                            Authorizer(0-10K)<em>*</em>
                          </label>
                        </MDBCol>

                        <MDBCol>
                          <input
                            type="text"
                            value={this.state.authModalValue}
                            disabled={true}
                            className="textbox"
                          />
                        </MDBCol>
                      </MDBRow>
                      <br></br>
                      <MDBRow>
                        <MDBCol>
                          <label>
                            Currency -0<em>*</em>
                          </label>
                        </MDBCol>
                        <MDBCol>
                          <input
                            type="text"
                            value={this.state.currencyModalValue}
                            disabled={true}
                            className="textbox"
                          ></input>
                        </MDBCol>
                      </MDBRow>
                      <br></br>
                      <MDBRow>
                        <MDBCol>
                          <label>
                            Approver (10-50K) <em>*</em>
                          </label>
                        </MDBCol>

                        <MDBCol>
                          {" "}
                          <DropDownList
                            class="k-input k-textbox"
                            style={{ width: "230px" }}
                            data={this.state.ddFirstLevelData}
                            dataItemKey="USERNAME"
                            textField="FULLNAME"
                            onChange={this.approverLevel1Change}
                            value={this.state.approverlevel1Value}
                          ></DropDownList>
                        </MDBCol>
                      </MDBRow>
                      <br></br>
                      <MDBRow>
                        <MDBCol>
                          <label>
                            Approver (50-100K) <em>*</em>
                          </label>
                        </MDBCol>

                        <MDBCol>
                          {" "}
                          <DropDownList
                            class="k-input k-textbox"
                            style={{ width: "230px" }}
                            data={this.state.ddSecondLevelData}
                            dataItemKey="USERNAME"
                            textField="FULLNAME"
                            onChange={this.approverLevel2Change}
                            value={this.state.approverlevel2Value}
                          ></DropDownList>
                        </MDBCol>
                      </MDBRow>
                      <br></br>
                      <MDBRow>
                        <MDBCol>
                          <label>
                            Approver (100-999K) <em>*</em>
                          </label>
                        </MDBCol>

                        <MDBCol>
                          {" "}
                          <DropDownList
                            class="k-input k-textbox"
                            style={{ width: "230px" }}
                            data={this.state.ddThirdLevelData}
                            dataItemKey="USERNAME"
                            textField="FULLNAME"
                            onChange={this.approverLevel3Change}
                            value={this.state.approverlevel3Value}
                          ></DropDownList>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </fieldset>
                  <br></br>
                  <div className="text-right">
                    <button
                      type="button"
                      style={{ marginRight: "10px" }}
                      className="btn k-button k-button-icontext"
                      onClick={this.submitData.bind(this)}
                    >
                      {this.state.SubmitbuttonName}
                    </button>
                    <button
                      type="button"
                      className="btn k-button k-button-icontext rejectbtn"
                      onClick={this.closeWindow.bind(this)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </Window>
            )}
            {this.state.visible && (
              <Dialog title={"Warning"} onClose={this.toggleDialog}>
                <p style={{ margin: "25px", textAlign: "center" }}>
                  {this.state.errorMessage}
                </p>
                <DialogActionsBar>
                  <button className="k-button" onClick={this.toggleDialog}>
                    OK
                  </button>
                </DialogActionsBar>
              </Dialog>
            )}

            {this.state.deletevisible && (
              <Dialog
                title={"Confirmation"}
                onClose={this.cancelDialog.bind(this)}
              >
                <p style={{ margin: "25px", textAlign: "center", color: "#004a86" }}>
                  Do you want to Delete the Approval Matrix
                </p>
                <DialogActionsBar>
                  <button
                    className="btn k-button"
                    onClick={this.cancelDialog.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn k-button"
                    onClick={this.deleteApprovalData.bind(this)}
                  >
                    OK
                  </button>
                </DialogActionsBar>
              </Dialog>
            )}
          </div>
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol sm="12" className="titleBox">
                <label>Approval Matrix</label>
              </MDBCol>
            </MDBRow>
          </MDBContainer>

          <MDBContainer fluid className="approvemtrix pl-5">
            <MDBRow>
              <MDBCol md="2">
                <label style={{ marginTop: "7px" }}>
                  Segment <em>*</em>
                </label>
              </MDBCol>
              <MDBCol md="3">
                <DropDownList
                  data={this.state.segmentData}
                  value={this.state.selectSegment}
                  dataItemKey="text"
                  textField="text"
                  onChange={this.handleSegmentChange}
                ></DropDownList>
              </MDBCol>
              <MDBCol md="2">
                <label style={{ marginTop: "7px" }}>Authorizer</label>
              </MDBCol>
              <MDBCol md="4">
                <AutoComplete
                  data={this.state.approverData}
                  disabled={this.state.authorizerTextDisabled}
                  value={this.state.selectedAuthToDisplay}
                  onChange={this.onApproverChange}
                  placeholder="Select Authorizer"
                  onBlur={this.onBlurApprover}
                  onFocus={this.onFocusAutoComplete}
                  style={{ width: "300px" }}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="2"></MDBCol>
              <MDBCol md="3"></MDBCol>
              <MDBCol md="2"></MDBCol>
              <MDBCol md="4">
                <span>
                  <small>Search by IDSID or EMAIL ID of Requestors</small>
                </span>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol>
                <p className="btnalign">
                  <button
                    type="submit"
                    className="btn k-button k-button-icontext mt"
                    disabled={this.state.searchDisabled}
                    onClick={this.searchData.bind(this)}
                  >
                    Search
                  </button>
                </p>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <br></br>
          <MDBContainer fluid>
            <MDBRow>
              <div className="displayData" id="kendoGrid">
                {grid}
              </div>
            </MDBRow>
          </MDBContainer>
        </BlockUi>
      </div>
    );
  }
}

export default ApproverMatrix;
